import { render, staticRenderFns } from "./AjetFareFeatures.vue?vue&type=template&id=1ee4c800&scoped=true&"
import script from "./AjetFareFeatures.vue?vue&type=script&lang=js&"
export * from "./AjetFareFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee4c800",
  null
  
)

export default component.exports